import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LayersIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, heroBadges, heroCta, heroGuarantee, heroImage, heroNote } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-136" data-mp="4n9wadwh9812">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-137" data-mp="128fqlljlahwr">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="inline-flex items-center gap-2 text-sm font-extrabold uppercase tracking-wider text-blue-600 sm:text-base md:text-lg md:tracking-widest" data-id="element-138" data-mp="xanra6gm7tij">
          <LayersIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-139" data-mp="3d1sakxd0hjt4" />
          {brand.name}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl text-4xl font-extrabold leading-none tracking-tight text-slate-900 sm:text-5xl md:text-6xl" data-id="element-140" data-mp="381nu37c3sp2w">
          {brand.promise}
          <br data-id="element-141" data-mp="39cfkx0rpn1u1" />
          <span className="text-blue-600" data-id="element-142" data-mp="3e9fq79gqk0k3">{brand.promiseAccent}</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.14,
        ease
      }} src={heroImage} alt="L'Atlante completo: 100 mappe visive + 6 bonus inclusi" className="mx-auto mt-10 w-full max-w-2xl" width={1240} height={1240} data-id="element-143" data-mp="3eb92b4a4bczh" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.2,
        ease
      }} className="mx-auto mt-10 max-w-3xl" data-id="element-144" data-mp="2vj7sx7zpw4bt">
          <p className="text-xl leading-relaxed text-blue-900/80 md:text-2xl" data-id="element-145" data-mp="2lmlcqwic61g4">{brand.subtitle}</p>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-blue-900/70" data-id="element-146" data-mp="s3umzlkswo5c">
            {heroBadges.map(badge => <li key={badge} className="inline-flex items-center gap-1.5" data-id="element-147" data-mp="ichz1524ii4l">
                <CheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-148" data-mp="degf6hwvies2" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-149" data-mp="161szsmjh4ciq">
            <CtaButton size="xl" className="w-full max-w-2xl" data-id="element-150" data-mp="162ued0zp7h57">
              {heroCta}
            </CtaButton>
            <p className="mx-auto mt-3 max-w-xl text-sm text-blue-900/60" data-id="element-151" data-mp="111err4hvh2kp">{heroNote}</p>
          </div>

          <p className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-blue-900/70" data-id="element-152" data-mp="x0l50eg61tte">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-153" data-mp="3lui9qrz2d1lw" />
            {heroGuarantee}
          </p>
        </motion.div>
      </div>
    </section>;
}